import { VALIDATION, PRIVATE_KEY } from "consts";
import { WEEKDAYS, STATIC_URLS, daysInMonth } from "./consts";
import CryptoJS from "crypto-js";
import cryptoJs from "crypto-js";
import Cookies from "js-cookie";
import Pako from "pako";
// Add New Item in Array
export const insertItem = (array, item, index) => {
  let newArray = array.slice();
  newArray.splice(index, 0, item);
  return newArray;
};

// Add multiple Items in Array
export const insertMultipleItems = (array, items, index) => {
  let newArray = array.slice();
  newArray.push.apply(newArray, items);
  return newArray;
};

// Remove Item in Array
export const removeItem = (array, index) => {
  return array.filter((item, i) => i !== index);
};

// Update Object with new props
export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties
  };
};

// Deep copy of obj
export const deepClone = obj => {
  return JSON.parse(JSON.stringify(obj));
};

//sort numbers
export function sortNumbers(arr) {
  return arr.slice().sort((a, b) => a - b);
}

// Create a range of numbers from start to start + length - 1
export const createNumberRange = (length, start = 1) => {
  return Array.from({ length }, (_, i) => start + i);
};

// Reduce the array to string
export const arrayToString = (array, prop) => {
  return array.reduce((total, val, index, arr) => {
    let pivot = null;

    if (index === 0) pivot = "";
    else if (index === arr.length - 1) pivot = " and ";
    else pivot = ", ";

    return total + pivot + (prop ? val[prop] : val);
  }, "");
};

// Formate Bytes to Related suffix
export const formatBytes = bytes => {
  if (bytes === 0 || bytes === "0") return "0 B";
  const k = 1024,
    sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

// Formate Bps to Related suffix
export const formatBytesPerSec = bps => {
  bps = bps * 8;
  if (bps === 0 || bps === "0") return "0 bps";
  const k = 1000,
    sizes = [
      "bps",
      "Kbps",
      "Mbps",
      "Gbps",
      "Tbps",
      "Pbps",
      "Ebps",
      "Zbps",
      "Ybps"
    ],
    i = Math.floor(Math.log(bps) / Math.log(k));
  return parseFloat((bps / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const formatBitesPerSec = bps => {
  if (bps === 0) return "0 bps";
  const k = 1000,
    sizes = [
      "bps",
      "Kbps",
      "Mbps",
      "Gbps",
      "Tbps",
      "Pbps",
      "Ebps",
      "Zbps",
      "Ybps"
    ],
    i = Math.floor(Math.log(bps) / Math.log(k));
  return parseFloat((bps / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const estimatedTime = (bytes, bps) => {
  if (bps === 0) return "estimating";
  let seconds = Math.floor(bytes / bps);
  let d = Math.floor(seconds / (3600 * 24));
  let h = Math.floor((seconds % (3600 * 24)) / 3600);
  let m = Math.floor((seconds % 3600) / 60);
  let s = Math.floor(seconds % 60);

  let dDisplay = d > 0 ? d + (d === 1 ? " Day" : " Days") : "";
  let hDisplay = h > 0 ? h + (h === 1 ? " Hr" : " Hrs ") : "";
  let mDisplay = m > 0 ? m + (m === 1 ? " Min" : " Mins") : "";
  let sDisplay = s > 0 ? s + (s === 1 ? " Sec" : " Secs") : "";

  if (dDisplay) return dDisplay + ", " + hDisplay;
  else if (hDisplay) return hDisplay + ", " + mDisplay;
  else if (mDisplay) return mDisplay + ", " + sDisplay;
  else if (sDisplay) return sDisplay;
  else return "0 Sec";
};

// Convert Array to Object
export const arrayToObject = (array, keyField) =>
  array.reduce((obj, item) => {
    obj[item[keyField]] = item;
    return obj;
  }, {});

// Convert Object to Array
export const objectToArray = (object, values, desc, listType) => {
  let array = Object.values(deepClone(object));

  if (values) {
    if (Array.isArray(values)) {
      values.forEach(v =>
        array.sort(function(a, b) {
          if (
            (typeof a[v] === "string" ? a[v].toLowerCase() : a[v]) <
            (typeof b[v] === "string" ? b[v].toLowerCase() : b[v])
          ) {
            return -1;
          }

          if (a[v] > b[v]) {
            return 1;
          }

          return 0;
        })
      );
    } else {
      array.sort(function(a, b) {
        let sortParams =
          a[values[1]] === b[values[1]] && ["clients"].includes(listType)
            ? values[2]
            : values[1];

        let [sortValue, cAsc] =
          sortParams.split("/").length > 1
            ? [sortParams.split("/")[0], sortParams.split("/")[1] === -1]
            : [sortParams];

        if (cAsc) {
          if (a[sortValue] < b[sortValue]) {
            return 1;
          }
          if (a[sortValue] > b[sortValue]) {
            return -1;
          }
        } else {
          if (a[sortValue] < b[sortValue]) {
            return -1;
          }
          if (a[sortValue] > b[sortValue]) {
            return 1;
          }
        }

        return 0;
      });
    }
  }

  if (desc) array.reverse();

  return array;
};

// Sort Array by Value
export const sortArray = (array, value, desc) => {
  array.sort((a, b) => {
    a = value ? a[value] : a;
    b = value ? b[value] : b;
    if (a === null) {
      return -1;
    }
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  });

  if (desc) array.reverse();

  return array;
};

export const sortArrayByKey = (data, key, desc = false) => {
  const array = Array.isArray(data)
    ? data
    : data && typeof data === "object"
    ? Object.values(deepClone(data))
    : [];

  if (array.length === 0) return array;

  const sortedArray = [...array].sort((a, b) => {
    if (a[key] === b[key]) return 0;
    if (a[key] == null) return 1;
    if (b[key] == null) return -1;
    if (typeof a[key] === "string" && typeof b[key] === "string") {
      return a[key].localeCompare(b[key]);
    }

    return a[key] > b[key] ? 1 : -1;
  });

  return desc ? sortedArray.reverse() : sortedArray;
};

// Sort Array by multiple values
export const sortMultiArray = (array, values, desc) => {
  if (typeof values === "object")
    values.forEach(value => {
      array.sort((a, b) => {
        a = value ? a[value] : a;
        b = value ? b[value] : b;
        if (a === null || a === undefined || b === null || b === undefined) {
          return -1;
        }
        if (a.toString().toLowerCase() < b.toString().toLowerCase()) {
          return -1;
        }
        if (a.toString().toLowerCase() > b.toString().toLowerCase()) {
          return 1;
        }
        return 0;
      });
    });

  if (desc) array.reverse();

  return array;
};

export const sortVolumes = (volList, value, desc = false) => {
  const volumes = sortArray(volList, value, desc);
  const sysvol = volumes.filter(v => v.drive === "SYSVOL");
  const espvol = volumes.filter(v => v.drive === "ESPVOL");
  const others = volumes.filter(
    v => v.drive !== "SYSVOL" && v.drive !== "ESPVOL"
  );
  return [...sysvol, ...espvol, ...others];
};

export function decodeHandler(value) {
  var decodingMap = {
    "%2D": "-",
    "%5F": "_",
    "%2E": ".",
    "%21": "!",
    "%7E": "~",
    "%2A": "*",
    "%27": "'",
    "%28": "(",
    "%29": ")"
  };
  let result = "";
  try {
    result = decodeURIComponent(value);
  } catch (e) {
    result = value;
  }

  return result;
}

export function encodeHandler(value) {
  var encodingMap = {
    "!": "%21",
    "*": "%2A",
    "'": "%27",
    "(": "%28",
    ")": "%29"
  };
  var pattern = /[!*()']/g;

  let result = "";
  if (pattern.test(encodeURIComponent(value))) {
    result = encodeURIComponent(value).replace(pattern, function(match) {
      return encodingMap[match];
    });
  } else {
    result = encodeURIComponent(value);
  }
  return result;
}

// Sort Array by Value lower  case
export const sortArrayLower = (array, value, desc) => {
  array.sort((a, b) => {
    a = value
      ? typeof a[value] === "string"
        ? a[value].toLocaleLowerCase()
        : a[value]
      : a;
    b = value
      ? typeof b[value] === "string"
        ? b[value].toLocaleLowerCase()
        : b[value]
      : b;
    if (a === null) {
      return -1;
    }
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  });

  if (desc) array.reverse();

  return array;
};

// Convert Time to Seconds
export const convertHmToSecs = hm => {
  const a = hm.split(":");
  return +a[0] * 60 * 60 + +a[1] * 60;
};

export const convertHMToSecs = (hr, min) => {
  return hr * 60 * 60 + min * 60;
};

// Convert Seconds to Time
export const convertSecsToHm = (secs, hm) => {
  switch (hm) {
    case "hm":
      let h = Math.floor(secs / 3600);
      if (h.toString().length === 1) h = "0" + h;
      const m = secs / 3600 - h ? (secs / 3600 - h) * 60 : "00";
      return [h, m].join(":");
    default:
      return secs / 60;
  }
};

// Convert Seconds to Hours or Mins or Secs in words
export const convertSecsToWords = secs => {
  if (secs > 3600) {
    let h = secs / 3600;
    return h <= 9 ? (h === 1 ? "0" + h + " Hr" : "0" + h + " Hrs") : h + " Hrs";
  } else if (secs > 60) {
    let m = secs / 60;
    return m <= 9
      ? m === 1
        ? "0" + m + " Min"
        : "0" + m + " Mins"
      : m + " Mins";
  } else
    return secs <= 9
      ? secs === 1 || secs === 0
        ? "0" + secs + " Sec"
        : "0" + secs + " Secs"
      : secs + " Secs";
};

// Pad Zero to numbers less than 10
export const padZero = n => {
  return n < 10 ? "0" + n : n;
};

// Date conversion from EPOC to Locale
export function epocToDate(epoc, format, utc) {
  const MMMM = [
    "\x00",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  const MMM = [
    "\x01",
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  const dddd = [
    "\x02",
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ];
  const ddd = ["\x03", "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  function ii(i, len) {
    let s = i + "";
    len = len || 2;
    while (s.length < len) s = "0" + s;
    return s;
  }
  const date = new Date(0);
  date.setUTCSeconds(epoc);

  const y = utc ? date.getUTCFullYear() : date.getFullYear();
  format = format.replace(/(^|[^\\])yyyy+/g, "$1" + y);
  format = format.replace(/(^|[^\\])yy/g, "$1" + y.toString().substr(2, 2));
  format = format.replace(/(^|[^\\])y/g, "$1" + y);

  const M = (utc ? date.getUTCMonth() : date.getMonth()) + 1;
  format = format.replace(/(^|[^\\])MMMM+/g, "$1" + MMMM[0]);
  format = format.replace(/(^|[^\\])MMM/g, "$1" + MMM[0]);
  format = format.replace(/(^|[^\\])MM/g, "$1" + ii(M));
  format = format.replace(/(^|[^\\])M/g, "$1" + M);

  const d = utc ? date.getUTCDate() : date.getDate();
  format = format.replace(/(^|[^\\])dddd+/g, "$1" + dddd[0]);
  format = format.replace(/(^|[^\\])ddd/g, "$1" + ddd[0]);
  format = format.replace(/(^|[^\\])dd/g, "$1" + ii(d));
  format = format.replace(/(^|[^\\])d/g, "$1" + d);

  const H = utc ? date.getUTCHours() : date.getHours();
  format = format.replace(/(^|[^\\])HH+/g, "$1" + ii(H));
  format = format.replace(/(^|[^\\])H/g, "$1" + H);

  let h = null;

  if (format.match(/(^|[^\\])(T|TT|t|tt)+/g)) {
    h = H > 12 ? H - 12 : H === 0 ? 12 : H;
    format = format.replace(/(^|[^\\])hh+/g, "$1" + ii(h));
    format = format.replace(/(^|[^\\])h/g, "$1" + h);

    const T = H < 12 ? "AM" : "PM";
    format = format.replace(/(^|[^\\])TT+/g, "$1" + T);
    format = format.replace(/(^|[^\\])T/g, "$1" + T.charAt(0));

    const t = T.toLowerCase();
    format = format.replace(/(^|[^\\])tt+/g, "$1" + t);
    format = format.replace(/(^|[^\\])t/g, "$1" + t.charAt(0));
  } else {
    h = H;
    format = format.replace(/(^|[^\\])hh+/g, "$1" + ii(h));
  }

  const m = utc ? date.getUTCMinutes() : date.getMinutes();
  format = format.replace(/(^|[^\\])mm+/g, "$1" + ii(m));
  format = format.replace(/(^|[^\\])m/g, "$1" + m);

  const s = utc ? date.getUTCSeconds() : date.getSeconds();
  format = format.replace(/(^|[^\\])ss+/g, "$1" + ii(s));
  format = format.replace(/(^|[^\\])s/g, "$1" + s);

  let f = utc ? date.getUTCMilliseconds() : date.getMilliseconds();
  format = format.replace(/(^|[^\\])fff+/g, "$1" + ii(f, 3));
  f = Math.round(f / 10);
  format = format.replace(/(^|[^\\])ff/g, "$1" + ii(f));
  f = Math.round(f / 10);
  format = format.replace(/(^|[^\\])f/g, "$1" + f);

  let tz = -date.getTimezoneOffset();
  let K = utc || !tz ? "Z" : tz > 0 ? "+" : "-";
  if (!utc) {
    tz = Math.abs(tz);
    var tzHrs = Math.floor(tz / 60);
    var tzMin = tz % 60;
    K += ii(tzHrs) + ":" + ii(tzMin);
  }
  format = format.replace(/(^|[^\\])K/g, "$1" + K);

  const day = (utc ? date.getUTCDay() : date.getDay()) + 1;
  format = format.replace(new RegExp(dddd[0], "g"), dddd[day]);
  format = format.replace(new RegExp(ddd[0], "g"), ddd[day]);

  format = format.replace(new RegExp(MMMM[0], "g"), MMMM[M]);
  format = format.replace(new RegExp(MMM[0], "g"), MMM[M]);

  format = format.replace(/\\(.)/g, "$1");

  return format;
}

// Prop Types Helper
export function forbidExtraProps(propTypes, ignoreTypes) {
  if (typeof propTypes !== "object") {
    throw new TypeError(
      `Wrong argument type 'propTypes' supplied to 'forbidExtraProps'. Expected 'object', got '${typeof propTypes}'.`
    );
  }

  const allowedPropKeys = Object.keys(propTypes);

  return {
    ...propTypes,
    _extraPropsCheck: conditionalPropType(
      props => {
        const unknownProps = Object.keys(props).filter(
          p => !ignoreTypes.includes(p) && !allowedPropKeys.includes(p)
        );
        return unknownProps.length > 0 ? unknownProps : false;
      },
      (unknownProps, _p, _pN, componentName) =>
        `Unknown props found in component '${componentName}': ${unknownProps.join(
          ", "
        )}.`,
      true
    )
  };
}

function conditionalPropType(condition, message, fullMessageOverride = false) {
  if (typeof condition !== "function")
    throw new TypeError(
      `Wrong argument type 'condition' supplied to 'conditionalPropType'. Expected 'function', got '${typeof condition}'.`
    );

  return function(props, propName, componentName) {
    const conditionResult = condition(props, propName, componentName);
    if (conditionResult) {
      const parsedMessage =
        typeof message === "function"
          ? message(conditionResult, props, propName, componentName)
          : message;
      const defaultMessage = `Invalid prop '${propName}' '${props[propName]}' supplied to '${componentName}'. ${parsedMessage}`;
      return new Error(fullMessageOverride ? parsedMessage : defaultMessage);
    }
  };
}

// Check Validity
let newPasswordValue = "";
export const checkValidity = (value, rules, errorFieldName) => {
  let isValid = true;
  let errMsg = "";

  if (!rules || (!rules.required && value.trim() === "")) {
    return { isValid, errMsg };
  }

  if (value === "") {
    isValid = false;
    if (errorFieldName) {
      if (errorFieldName.toLowerCase().includes("email")) {
        errMsg = VALIDATION.formFields.blank.email;
      } else if (errorFieldName.toLowerCase().includes("oldpassword")) {
        errMsg = VALIDATION.formFields.blank.currentPassword;
      } else if (errorFieldName.toLowerCase().includes("newpassword")) {
        errMsg = VALIDATION.formFields.blank.newPassword;
      } else if (errorFieldName.toLowerCase().includes("confirm")) {
        errMsg = VALIDATION.formFields.blank.confirm;
      } else if (errorFieldName.toLowerCase().includes("password")) {
        errMsg = VALIDATION.formFields.blank.password;
      } else if (errorFieldName.toLowerCase().includes("first")) {
        errMsg = VALIDATION.formFields.blank.firstName;
      } else if (errorFieldName.toLowerCase().includes("last")) {
        errMsg = VALIDATION.formFields.blank.lastName;
      } else if (errorFieldName.toLowerCase().includes("phone")) {
        errMsg = VALIDATION.formFields.blank.phone;
      } else if (errorFieldName.toLowerCase().includes("reason")) {
        errMsg = VALIDATION.formFields.blank.reason;
      } else {
        errMsg = VALIDATION.formFields.default;
      }
    } else {
      errMsg = VALIDATION.formFields.default;
    }
  }

  if (rules.isOnlyAlpha && isValid) {
    const newValue = value.replace(/ /g, "");

    isValid = /^[A-Z]+$/i.test(newValue);
    errMsg = isValid ? "" : VALIDATION.formFields[errorFieldName];
  }

  if (rules.isEmail && isValid) {
    const pattern = /^([a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*)@([a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)*)$/i;

    isValid = pattern.test(value);
    errMsg = isValid ? "" : VALIDATION.formFields.email;
  }

  if (rules.isPassword && isValid) {
    isValid = value.length >= 6;
    errMsg = isValid ? "" : VALIDATION.formFields.password.minLength;
  }

  if (rules.isPhoneNumber && isValid) {
    value = value.replace(/ /g, "");
    isValid = value.length === 10;
    errMsg = isValid ? "" : VALIDATION.formFields.phone;
  }

  if (rules.isNewPass) {
    newPasswordValue = value;
  }

  if (rules.isConfirmNewPass && isValid) {
    isValid = value === newPasswordValue;
    errMsg = isValid ? "" : VALIDATION.formFields.password.match;
  }

  // if (rules.isNumeric && isValid) {
  //   const pattern = /^\d+$/;

  //   isValid = pattern.test(value.replace(/ /g, ""));
  //   errMsg = isValid ? "" : "Enter a numeric value";
  // }

  return { isValid, errMsg };
};

// Check password strength
export function checkPassStrength(pass) {
  if (pass === "") return "";
  var score = scorePassword(pass);
  if (score >= 70) return "strong";
  if (score >= 50) return "good";
  if (score >= 30) return "weak";

  return "weak";
}

function scorePassword(pass) {
  var score = 0;
  if (!pass) return score;

  // award every unique letter until 5 repetitions
  var letters = {};
  for (var i = 0; i < pass.length; i++) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1;
    score += 5.0 / letters[pass[i]];
  }

  // bonus points for mixing it up
  let variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass)
  };

  let variationCount = 0;
  for (var check in variations) {
    variationCount += variations[check] === true ? 1 : 0;
  }
  score += (variationCount - 1) * 10;

  return parseInt(score);
}

// Socket reconnection
export function waitForConnection(ws, req, interval) {
  if (ws.readyState === 1) {
    console.log(req);
    req.loginId = decryptData(localStorage.getItem("mirrorId"));
    req.data = JSON.stringify(req.data);

    ws.send(JSON.stringify(req));
  } else {
    setTimeout(function() {
      waitForConnection(ws, req, interval);
    }, interval);
  }
}

// Extract query params
export function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function formatTimeDuration(t) {
  var d = Math.floor(t / 86400),
    h = ("0" + (Math.floor(t / 3600) % 24)).slice(-2),
    m = ("0" + (Math.floor(t / 60) % 60)).slice(-2),
    s = ("0" + (t % 60)).slice(-2);
  return (
    (d > 0 ? d + "D " : "") +
    (h > 0 ? h + "H: " : "") +
    (m > 0 ? m + "M: " : "") +
    (t > 60 ? s + "S" : s + "S")
    // (d > 0 ? "d" : h > 0 ? "h" : m > 0 ? "m" : "s")
  );
}

//Local download from url
export function localDownload(url) {
  // url = "http://192.168.1.51:4444/api/v1/" + url;
  const a = document.createElement("A");
  a.href = url;
  a.download = url.substr(url.lastIndexOf("/") + 1);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function deepFindOfObj(obj, path) {
  const paths = path.split(".");
  let current = obj;

  for (let i = 0; i < paths.length; ++i) {
    if (current[paths[i]] === undefined) {
      return undefined;
    } else {
      current = current[paths[i]];
    }
  }

  return current;
}

export function deepSetInObj(obj, value, path) {
  let schema = obj;
  const pList = path.split(".");
  let len = pList.length;

  for (var i = 0; i < len - 1; i++) {
    const elem = pList[i];

    if (!schema[elem]) schema[elem] = {};
    schema = schema[elem];
  }

  schema[pList[len - 1]] = value;
}

export const deepDiffMapper = (function() {
  return {
    VALUE_CREATED: "created",
    VALUE_UPDATED: "updated",
    VALUE_DELETED: "deleted",
    VALUE_UNCHANGED: "unchanged",
    map: function(obj1, obj2) {
      if (this.isFunction(obj1) || this.isFunction(obj2)) {
        throw "Invalid argument. Function given, object expected.";
      }
      if (this.isValue(obj1) || this.isValue(obj2)) {
        return {
          type: this.compareValues(obj1, obj2),
          data: obj1 === undefined ? obj2 : obj1
        };
      }

      let diff = {};
      for (let key in obj1) {
        if (this.isFunction(obj1[key])) {
          continue;
        }

        let value2 = undefined;
        if (obj2[key] !== undefined) {
          value2 = obj2[key];
        }

        diff[key] = this.map(obj1[key], value2);
      }
      for (let key in obj2) {
        if (this.isFunction(obj2[key]) || diff[key] !== undefined) {
          continue;
        }

        diff[key] = this.map(undefined, obj2[key]);
      }

      return diff;
    },
    compareValues: function(value1, value2) {
      if (value1 === value2) {
        return this.VALUE_UNCHANGED;
      }
      if (
        this.isDate(value1) &&
        this.isDate(value2) &&
        value1.getTime() === value2.getTime()
      ) {
        return this.VALUE_UNCHANGED;
      }
      if (value1 === undefined) {
        return this.VALUE_CREATED;
      }
      if (value2 === undefined) {
        return this.VALUE_DELETED;
      }
      return this.VALUE_UPDATED;
    },
    isFunction: function(x) {
      return Object.prototype.toString.call(x) === "[object Function]";
    },
    isArray: function(x) {
      return Object.prototype.toString.call(x) === "[object Array]";
    },
    isDate: function(x) {
      return Object.prototype.toString.call(x) === "[object Date]";
    },
    isObject: function(x) {
      return Object.prototype.toString.call(x) === "[object Object]";
    },
    isValue: function(x) {
      return !this.isObject(x) && !this.isArray(x);
    }
  };
})();

export function deepCompare(x, y) {
  var i, l, leftChain, rightChain;

  compare2Objects(x, y);
  function compare2Objects(x, y) {
    var p;

    // remember that NaN === NaN returns false
    // and isNaN(undefined) returns true
    if (
      isNaN(x) &&
      isNaN(y) &&
      typeof x === "number" &&
      typeof y === "number"
    ) {
      return true;
    }

    // Compare primitives and functions.
    // Check if both arguments link to the same object.
    // Especially useful on the step where we compare prototypes
    if (x === y) {
      return true;
    }

    // Works in case when functions are created in constructor.
    // Comparing dates is a common scenario. Another built-ins?
    // We can even handle functions passed across iframes
    if (
      (typeof x === "function" && typeof y === "function") ||
      (x instanceof Date && y instanceof Date) ||
      (x instanceof RegExp && y instanceof RegExp) ||
      (x instanceof String && y instanceof String) ||
      (x instanceof Number && y instanceof Number)
    ) {
      return x.toString() === y.toString();
    }

    // At last checking prototypes as good as we can
    if (!(x instanceof Object && y instanceof Object)) {
      return false;
    }

    if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
      return false;
    }

    if (x.constructor !== y.constructor) {
      return false;
    }

    if (x.prototype !== y.prototype) {
      return false;
    }

    // Check for infinitive linking loops
    if (leftChain !== undefined && rightChain !== undefined) {
      if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
        return false;
      }
    }

    // Quick checking of one object being a subset of another.
    for (p in y) {
      if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
        return false;
      } else if (typeof y[p] !== typeof x[p]) {
        return false;
      }
    }

    for (p in x) {
      if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
        return false;
      } else if (typeof y[p] !== typeof x[p]) {
        return false;
      }

      switch (typeof x[p]) {
        case "object":
        case "function":
          if (leftChain === undefined) leftChain = [];
          if (rightChain === undefined) rightChain = [];
          leftChain.push(x);
          rightChain.push(y);

          if (!compare2Objects(x[p], y[p])) {
            return false;
          }

          leftChain.pop();
          rightChain.pop();
          break;

        default:
          if (x[p] !== y[p]) {
            return false;
          }
          break;
      }
    }

    return true;
  }

  if (arguments.length < 1) {
    return true; //Die silently? Don't know how to handle such case, please help...
    // throw "Need two or more arguments to compare";
  }

  for (i = 1, l = arguments.length; i < l; i++) {
    leftChain = [];
    rightChain = [];

    if (!compare2Objects(arguments[0], arguments[i])) {
      return false;
    }
  }

  return true;
}

export function convertBytesToMB(bytes) {
  return Math.round((bytes / (1024 * 1024)).toFixed(2));
}

//Used currently for truncate String Middle

//Get Text width
export function getTextWidth(text, font) {
  // re-use canvas object for better performance
  let canvas =
    getTextWidth.canvas ||
    (getTextWidth.canvas = document.createElement("canvas"));
  let context = canvas.getContext("2d");
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
}

export function getFontSizeFamily(element) {
  return (
    window.getComputedStyle(element, null).getPropertyValue("font-size") +
    " " +
    window.getComputedStyle(element, null).getPropertyValue("font-family")
  );
}

//Truncate String in middle with 3 dots...
export function truncateStringMiddle(
  str,
  element,
  offset = 0,
  customWidth = 0
) {
  const getElement = document.getElementById(element);

  if (getElement) {
    let elementWidth = getElement.clientWidth;
    if (customWidth) elementWidth = customWidth;
    const stringWidth = getTextWidth(str, getFontSizeFamily(getElement));
    if (stringWidth > elementWidth - offset) {
      elementWidth = elementWidth - offset;
      let dotsWidth = getTextWidth("...", getFontSizeFamily(getElement));
      let firstPart = "",
        secondPart = "";
      let firstPartWidth = dotsWidth / 2,
        secondPartWidth = dotsWidth / 2;
      str.split("").forEach(v => {
        let charWidth = getTextWidth(v, getFontSizeFamily(getElement));
        if (firstPartWidth < elementWidth / 2) {
          firstPartWidth = firstPartWidth + charWidth;
          firstPart = [firstPart, v].join("");
        } else {
          return;
        }
      });

      str
        .split("")
        .reverse()
        .forEach(v => {
          let charWidth = getTextWidth(v, getFontSizeFamily(getElement));
          if (secondPartWidth < elementWidth / 2) {
            secondPartWidth = secondPartWidth + charWidth;
            secondPart = [secondPart, v].join("");
          } else {
            return;
          }
        });

      firstPart = firstPart.slice(0, -1);
      secondPart = secondPart
        .split("")
        .reverse()
        .join("")
        .slice(1);

      return firstPart + "..." + secondPart;
    }
    return str;
  }
  return str;
}

//End of truncate string in middle

//Disable(1st parameter) and Enable of styleSheets

export function disableEnableStyleSheets(disable, enable) {
  Object.values(document.styleSheets).forEach(sheet => {
    if (disable.indexOf(sheet.href) > -1) sheet.disabled = true;
    if (enable.indexOf(sheet.href) > -1) sheet.disabled = false;
  });
}

export function aesEncryption(params) {
  const secret = params.md5(params.secret).toString();
  return params.encrypt(params.text, secret).toString();
}

//Encryption and Decryption functions for localStorage
export function encryptData(string) {
  let encrypted = CryptoJS.AES.encrypt(string, PRIVATE_KEY).toString();

  return encrypted;
}

export function decryptData(encrypted) {
  let decrypted = CryptoJS.AES.decrypt(encrypted, PRIVATE_KEY);
  let finalData = decrypted.toString(cryptoJs.enc.Utf8);

  return finalData;
}

//Encryption and Decryption for localForage
export function encryptDataArray(string) {
  let encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(string),
    PRIVATE_KEY
  ).toString();

  return encrypted;
}

export function decryptDataArray(encrypted) {
  let decrypted = CryptoJS.AES.decrypt(encrypted, PRIVATE_KEY);
  let finalData = JSON.parse(decrypted.toString(cryptoJs.enc.Utf8));

  return finalData;
}

export function isDecodable(string, display) {
  try {
    decodeURIComponent(string);
    return true;
  } catch (error) {
    console.log(display, "-decode issue-", string);
    return false;
  }
}

export function scrollToView(id, div) {
  const element = document.getElementById(id);
  if (element) {
    const offset = 45;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - offset;

    if (div) {
      const parentElement = document.getElementById(div);
      const topPos = element.offsetTop;
      parentElement.scrollTop = topPos;
    } else {
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }
}

export function outlineFocus(id, focus) {
  if (focus) {
    document
      .getElementById(id)
      .setAttribute(
        "style",
        "outline: -webkit-focus-ring-color auto 1px;outline-color: -webkit-focus-ring-color; outline-style: auto;outline-width: 1px;"
      );
  } else {
    document.getElementById(id).setAttribute("style", "outline: none;");
  }
}

export function calcDiscount(num, discount) {
  let number = num * ((100 - discount) / 100);
  return Math.floor(number * 100) / 100;
}

export function stringBreakLine(string, length) {
  let mainArr = [];
  for (let i = 0; i < string.length; i + length) {
    mainArr.push(string.substring(i, i + length));
    i = i + length;
  }
  return mainArr;
}

export function formatDateToMM(date) {
  const Date = [
    date.split("-")[1],
    date.split("-")[2],
    date.split("-")[0]
  ].join("-");
  return Date;
}

export function addMetaTagContent(name, content) {
  if (document.getElementsByTagName("meta")[name]) {
    document.getElementsByTagName("meta")[name].content = content;
  } else {
    const link = document.createElement("meta");
    link.setAttribute("name", name);
    link.content = content;
    document.getElementsByTagName("head")[0].appendChild(link);
  }
}

export function addLinkTagContent(name, url) {
  if (document.querySelector('link[rel="' + name + '"]')) {
    document.querySelector('link[rel="' + name + '"]').href = url;
  } else {
    const link = document.createElement("link");
    link.setAttribute("rel", name);
    link.href = url;
    document.getElementsByTagName("head")[0].appendChild(link);
  }
}

export const getWeekdaysName = selectedDays => {
  const days = [];
  objectToArray(WEEKDAYS, { 1: "priority" }).forEach(val => {
    if (selectedDays.includes(val.code)) {
      days.push(WEEKDAYS[val.code].name);
    }
  });
  return arrayToString(days);
};

export const firstLetterUpper = str => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export function validateEmail(str) {
  return /^([!#-\'*+\/-9=?A-Z^-~\\\\-]{1,64}(\.[!#-\'*+\/-9=?A-Z^-~\\\\-]{1,64})*|"([\]!#-[^-~\ \t\@\\\\]|(\\[\t\ -~]))+")@([0-9A-Z]([0-9A-Z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Z]([0-9A-Z-]{0,61}[0-9A-Za-z])?))+$/i.test(
    str
  );
}

export function formatSecsToHrRange(secs) {
  const hrs = Math.trunc(secs / 3600);
  const amPM = hrs => (hrs >= 12 ? "PM" : "AM");
  const formatHrs = hrs =>
    hrs === 0
      ? "12 AM"
      : hrs > 12
      ? hrs - 12 + " " + amPM(hrs)
      : hrs + " " + amPM(hrs);
  return (
    formatHrs(hrs) +
    " - " +
    (hrs + 1 === 24 ? formatHrs(0) : formatHrs(hrs + 1))
  );
}

export const formatTime12hr = secs => {
  const hour24 = Math.trunc(secs / 3600);
  const hrs = hour24 % 12 || 12;
  const min = Math.trunc((secs % 3600) / 60) || 0;
  const meridian = hour24 >= 12 ? "PM" : "AM";

  return {
    hrs: String(hrs).padStart(2, "0"),
    min: String(min).padStart(2, "0"),
    meridian
  };
};

export function formatMonths(keysArr, enumList) {
  const months = Object.entries(enumList)
    .sort((a, b) => a[1] - b[1])
    .slice(1)
    .filter(m => keysArr.includes(m[1]))
    .map(m => capitalizeFirst(m[0].slice(0, 3)));

  if (months.length === 12) return "month";

  if (months.length <= 1) return months[0] || "";

  return months.slice(0, -1).join(", ") + " and " + months.at(-1);
}

export function formatMonthsPlaceholder(keysArr, enumList) {
  const months = Object.entries(enumList)
    .sort((a, b) => a[1] - b[1])
    .slice(1)
    .filter(m => keysArr.includes(m[1]))
    .map(m => capitalizeFirst(m[0].slice(0, 3)));

  if (months.length === 12) return "All Months";

  if (months.length <= 1) return months[0] || "";

  return months.join(", ");
}

export const formatDates = dates => {
  const suffix = n =>
    n % 100 >= 11 && n % 100 <= 13
      ? "th"
      : ["th", "st", "nd", "rd"][n % 10] || "th";

  // return last day if 32
  if (dates.length === 1 && dates[0] === 32) return "the last day";

  // Remove duplicates and ignore invalid days (like 32, 0, etc.)
  const validDates = [...new Set(dates)]
    .filter(d => d >= 1 && d <= 31)
    .sort((a, b) => a - b);

  // If all days exist
  if (validDates.length === 31) return "all days";

  const arr = validDates.map(d => `${d}${suffix(d)}`);

  if (arr.length <= 1) return arr[0] || "";

  return `the ${arr.slice(0, -1).join(", ")} and ${arr.at(-1)}`;
};

export const formatDatesPlaceholder = dates => {
  // return last day if 32
  if (dates.length === 1 && dates[0] === 32) return "last day of the month";

  // Remove duplicates and ignore invalid days (like 32, 0, etc.)
  const validDates = [...new Set(dates)]
    .filter(d => d >= 1 && d <= 31)
    .sort((a, b) => a - b);

  // If all days exist
  if (validDates.length === 31) return "All Days";

  if (validDates.length < 1) return "";

  return (
    validDates.join(", ") +
    (dates.includes(32) ? ", last day of the month" : "")
  );
};

export function getNextScheduleMonthly(months, dates, timeSec) {
  const now = new Date();
  const year = now.getFullYear();

  const hrs = Math.floor(timeSec / 3600);
  const mins = Math.floor((timeSec % 3600) / 60);
  const secs = timeSec % 60;

  let nearest = null;

  // check this year and next year
  for (let y of [year, year + 1]) {
    for (let m of months) {
      const lastDayOfMonth = new Date(y, m, 0).getDate();

      for (let d of dates) {
        // if 32 → last day of month
        const day = d === 32 ? lastDayOfMonth : d;

        const candidate = new Date(y, m - 1, day, hrs, mins, secs);

        // skip invalid dates like Feb 30
        if (candidate.getMonth() !== m - 1) continue;

        if (candidate > now) {
          if (!nearest || candidate < nearest) {
            nearest = candidate;
          }
        }
      }
    }
  }

  return nearest ? Math.floor(nearest.getTime() / 1000) : null;
}

export const validDates = (months, dates) => {
  if (!Array.isArray(months) || !Array.isArray(dates)) return false;
  return (
    dates.includes(32) ||
    months.every(month => {
      if (!daysInMonth[month]) return false;

      return dates.some(date => {
        return date >= 1 && date <= daysInMonth[month];
      });
    })
  );
};

export function decompressionAlgorithm(nonCompressed) {
  try {
    var data = Pako.inflate(new Uint8Array(nonCompressed));
    return JSON.parse(new TextDecoder().decode(data));
  } catch (e) {
    console.log(e);
  }
}

export function debounceHandler(fun, delay) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fun(...args);
    }, delay);
  };
}

export function openWithPost(url, data, blankPage) {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = url;
  if (blankPage) {
    form.target = "_blank";
  }

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = data[key];
      form.appendChild(input);
    }
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}

export function checkAndStoreCookieValueForVirtualizationConsole(uuid) {
  const existingCookie = Cookies.get("469bb0e1c5e4");
  let existingHosts = existingCookie ? JSON.parse(existingCookie) : [];
  if (!existingHosts.includes(uuid)) {
    existingHosts.push(uuid);
    Cookies.set("469bb0e1c5e4", JSON.stringify(existingHosts), {
      domain: ".idrivemirror.com", // ✅ enables sharing across subdomains like www.idrivemirror.com and hyperv-or-01.idrivemirror.com
      path: "/"
    });
    return false;
  } else {
    return true;
  }
}
// Generate Unique ID
const getRandomLetters = (length = 1) =>
  Array(length)
    .fill()
    .map(e => String.fromCharCode(Math.floor(Math.random() * 26) + 65))
    .join("");
const getRandomDigits = (length = 1) =>
  Array(length)
    .fill()
    .map(e => Math.floor(Math.random() * 10))
    .join("");
export const generateUniqueID = () => {
  let id = getRandomLetters(4) + getRandomDigits(7);
  return id;
};

export const redirectToRPCVirtualizationConsole = machine_id => {
  const source = STATIC_URLS.rpcVirtualizationUrl.idrive;
  const loginId = decryptData(localStorage.getItem("mirrorId"));
  const url =
    source +
    loginId +
    `?machine_id=${machine_id}&authToken=${localStorage.getItem("token")}`;
  window.open(url, "_blank");
};

export const redirectToNoVNCVirtualizationConsole = (task_id, client_uuid) => {
  window.open(
    `${window.location.origin}/mirror/viconsole?taskId=${task_id}&clientUUID=${client_uuid}`,
    "_blank"
  );
};

export function compareVersions(v1, v2) {
  const a = v1.split(".").map(Number);
  const b = v2.split(".").map(Number);

  const length = Math.max(a.length, b.length);

  for (let i = 0; i < length; i++) {
    const partA = a[i] ?? 0;
    const partB = b[i] ?? 0;

    if (partA > partB) return 1; // v1 is greater
    if (partA < partB) return -1; // v2 is greater
  }

  return 0; // versions are equal
}

export function capitalizeFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function displayBackupSchedule(scheduleInfo, enums) {
  if (!scheduleInfo || !enums?.ScheduleType || !enums?.WeekDays)
    return "fetching...";
  let timeObj12hr = formatTime12hr(scheduleInfo.startTime);
  let time12hr =
    timeObj12hr.hrs + ":" + timeObj12hr.min + " " + timeObj12hr.meridian;

  switch (enums.ScheduleType.props[scheduleInfo.type].key) {
    case "INTERVAL":
      return "Every " + convertSecsToWords(scheduleInfo.interval.selected);
    case "DAILY":
      return "Everyday at " + time12hr;
    case "CUSTOM":
      const weekDays = [];
      objectToArray(enums.WeekDays.props, { 1: "priority" }).forEach(val => {
        if (scheduleInfo.weekDays.includes(val.code)) {
          weekDays.push(enums.WeekDays.props[val.code]);
        }
      });
      if (weekDays.length === 7) {
        return "Everyday at " + time12hr;
      }
      return "Every " + arrayToString(weekDays, "name") + " at " + time12hr;
    case "NO_SCHEDULE":
      return "Never";
    case "MONTHLY":
      return "Every selected month and day at " + time12hr;
    // return (
    //   "Every " +
    //   formatMonths(scheduleInfo.months, props.enums.Months) +
    //   " on " +
    //   formatDates(scheduleInfo.monthDays) +
    //   " at " +
    //   time12hr
    // );
    default:
      break;
  }
}

export function scrollIntoView(selectorQuery) {
  const _elm = document.querySelector(selectorQuery);
  if (_elm) {
    _elm.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest"
    });
  }
}
